// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Abux","unreadBadge":"styles_unreadBadge__2YBxm","modalContent":"styles_modalContent__1ZD14","modal":"styles_modal__93Zn0"};